import React, { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import CreateFrenchPuzzlesDialog from "./CreateFrenchPuzzlesDialog";
import AnythingService from "../AnythingService";

export default function CreateFrenchPuzzlesMain() {
    const [frenchDialogOpen, setFrenchDialogOpen] = useState(false);
    const [frenchDialogType, setFrenchDialogType] = useState(null);

    const handleCreateFrenchPuzzles = (type) => {
        setFrenchDialogType(type);
        setFrenchDialogOpen(true);
    };

    const handleExecuteFrenchPuzzles = async () => {
        if (frenchDialogType === "grid") {
            return await AnythingService.createFrenchVersionsForGrid();
        } else if (frenchDialogType === "crossword") {
            return await AnythingService.createFrenchVersionsForCrossword();
        }
        throw new Error("Invalid puzzle type");
    };

    return (
        <Box sx={{ flexGrow: 1, p: 3 }}>
            <Paper elevation={2} sx={{ p: 4 }}>
                <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', mb: 4 }}>
                    Create French Puzzles
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                    Create French versions based on ready-for-review English puzzles. This will only create French versions for English puzzles that don't already have French versions created.
                </Typography>

                <Grid container spacing={3}>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 3, border: '2px solid', borderColor: 'primary.main', borderRadius: 2 }}>
                            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                                Grid Puzzles
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 3, textAlign: 'center' }}>
                                Create French versions based on ready-for-review English Grid puzzles that don't have French versions yet.
                            </Typography>
                            <Button
                                variant="contained"
                                size="large"
                                onClick={() => handleCreateFrenchPuzzles("grid")}
                                sx={{ minWidth: 200 }}
                            >
                                Create
                            </Button>
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 3, border: '2px solid', borderColor: 'secondary.main', borderRadius: 2 }}>
                            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                                Crossword Puzzles
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 3, textAlign: 'center' }}>
                                Create French versions based on ready-for-review English Crossword puzzles that don't have French versions yet.
                            </Typography>
                            <Button
                                variant="contained"
                                color="secondary"
                                size="large"
                                onClick={() => handleCreateFrenchPuzzles("crossword")}
                                sx={{ minWidth: 200 }}
                            >
                                Create
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Paper>

            <CreateFrenchPuzzlesDialog
                open={frenchDialogOpen}
                onClose={() => setFrenchDialogOpen(false)}
                puzzleType={frenchDialogType}
                onExecute={handleExecuteFrenchPuzzles}
            />
        </Box>
    );
}
